import(/* webpackMode: "eager" */ "/app/apps/web/src/containers/layouts/main/main-layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/containers/layouts/simple/simple-layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/containers/sections/page/view/page-view.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/i18n-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/localization-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/use-locales.tsx");
